<template>
  <div id="container-sea-route" v-if="showSeaRoutes">
    <ul class="sea-route-scroll">
      <component
        :is="scrollbarTag"
        class="scroll-area--customizer"
        :settings="settings"
        :key="$vs.rtl"
      >
        <li v-for="route in this.seaRoutes" :key="route.number" class="item">
          <route-item :route="route"/>
        </li>
      </component>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import {
  ColorMixin,
  StoreMonitoringVesselManeuveringMixin
} from "@/mixins/addon/secure-dataflow";

// components
import RouteItem from "./components/RouteItem";

export default {
  name: "seaRoute",
  mixins: [ColorMixin, StoreMonitoringVesselManeuveringMixin],
  components: {
    VuePerfectScrollbar,
    RouteItem
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  watch: {
    veeringPoints(val) {
      this.validateSeaRoute()
    },
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 1,
        swipeEasing: true
      },
      showSeaRoutes: false
    };
  },
  methods: {
    validateSeaRoute() {
      if(!this.seaRoutes) return
      if (this.seaRoutes.length < this.veeringPoints.length) {
        Vue.$log.error(`[SDF] Incorrect number of points, sea route(${this.seaRoutes.length}) for veering points(${this.veeringPoints.length})`);
        this.showSeaRoutes = false
      } else {
        this.showSeaRoutes = true
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/secure-dataflow/monitoringVesselManeuvering/seaRoute.scss";
</style>
